import { BackButton, SecondaryButton } from "../../components";
import { SuccessIcon } from "../../assets/svg";
import { navigateTo } from "../../helper";
import { connect, useDispatch } from "react-redux";

import { RootState } from "../../store/root-reducer";
import { useTranslation } from "react-i18next";
import { cleanUpClaimInfo } from "../../store/ace-claim/actions";

function SubmitClaim({ claimNumber = "" }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClick = () => {
    dispatch(cleanUpClaimInfo());
    navigateTo("/");
  };

  return (
    <div className="px-2 mt-3">
      <BackButton onClick={handleClick} text={t("Home")} />
      <div className="flex  flex-col items-center gap-8 mt-4 px-2">
        <SuccessIcon size={98} />
        <span className="text-2xl font-semibold text-center ">
          {t("Thank you for submitting your claim.")}
        </span>
        <div className="bg-[#F8F8F8] border-[#EDEDED] border p-3 flex flex-col items-center rounded-lg gap-1">
          <span className="text-[#505050] text-lg">{t("Claim Number")}</span>
          <span className="font-semibold text-4xl text-[#22222C]">
            {claimNumber}
          </span>
        </div>
        <div className="bg-green-50 text-green-700 font-semibold border-green-500 border p-3 rounded-lg gap-1 text-center text-sm -my-5">
          You will receive a notification with a status update within the next
          2–3 business days. In the meantime, please keep an eye on your email
          for the latest updates.
        </div>
        <div className="space-y-3 w-full">
          <SecondaryButton onClick={handleClick}>
            {t("Back to Home")}
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state: RootState) => ({
  claimNumber: state?.aceClaim?.claimId,
});

export default connect(mapStateToProps)(SubmitClaim);
